import { useState, useEffect } from 'react';
import { getDfpNetworkConfig } from '../../api/dfpNetworkConfig';

/**
 * @name useDfpNetworkConfig
 * @description Custom hook to manage DFP Network Config state and fetching
 * This hook maintains the DFP Network Config data
 */
const useDfpNetworkConfig = () => {
	const [dfpNetworkConfig, setDfpNetworkConfig] = useState(null); // Contains the DFP Network Config doc

	/**
	 * @name fetchDfpNetworkConfig
	 * @description Fetches the DFP Network Config from the API
	 * This function updates the DFP Network Config state with the fetched data
	 */
	const fetchDfpNetworkConfig = async () => {
		try {
			const response = await getDfpNetworkConfig();
			setDfpNetworkConfig(response?.data?.data?.dfpNetworkConfig);
		} catch (error) {
			console.error('Error fetching DFP Network Config:', error);
		}
	};

	useEffect(() => {
		fetchDfpNetworkConfig();
	}, []);

	return {
		dfpNetworkConfig
	};
};

export default useDfpNetworkConfig;
